import React from "react";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { LOGO_URL, BUSINESS, SERVICES } from "@/data/content";

export default function Footer() {
  return (
    <footer
      className="relative bg-black border-t border-zinc-900 pt-24 pb-10"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-16 md:mb-24">
          <h3 className="font-display text-5xl sm:text-7xl md:text-[9rem] lg:text-[11rem] uppercase leading-[0.85] tracking-tighter text-white">
            Let&apos;s make it
            <br />
            <span className="text-[#C4FF00] text-glow-lime">Spotless.</span>
          </h3>
          <a
            href="#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#C4FF00] text-black hover:bg-[#D4FF33] px-6 h-12 text-sm font-bold uppercase tracking-widest transition-colors"
            data-testid="footer-cta-quote"
          >
            Get Quote
            <span aria-hidden>→</span>
          </a>
        </div>

        <div className="grid md:grid-cols-4 gap-10 pb-10 border-t border-zinc-900 pt-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt="Spotless Water Works"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
              {BUSINESS.tagline} — soft-wash & pressure washing serving all of
              South Florida.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-[#C4FF00] mb-4">
              Services
            </div>
            <ul className="space-y-2">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a
                    href="#services"
                    className="text-sm text-zinc-400 hover:text-white transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-[#C4FF00] mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li>
                <a
                  href={BUSINESS.phoneHref}
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone className="h-3.5 w-3.5" /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Mail className="h-3.5 w-3.5" /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5" /> West Palm Beach → Miami
              </li>
              <li>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 mt-1 text-[#C4FF00] hover:text-[#D4FF33] font-bold uppercase tracking-widest text-xs transition-colors"
                  data-testid="footer-link-quote"
                >
                  Get Quote →
                </a>
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://instagram.com/spotlesswaterworks"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="h-9 w-9 rounded-full border border-zinc-800 grid place-items-center text-zinc-400 hover:text-[#C4FF00] hover:border-[#C4FF00] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="h-9 w-9 rounded-full border border-zinc-800 grid place-items-center text-zinc-400 hover:text-[#C4FF00] hover:border-[#C4FF00] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-[#C4FF00] mb-4">
              Areas
            </div>
            <ul className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-zinc-400">
              {BUSINESS.areas.slice(0, 8).map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-zinc-600 pt-6 border-t border-zinc-900">
          <div>
            © {new Date().getFullYear()} Spotless Water Works. All rights reserved.
          </div>
          <div className="uppercase tracking-widest font-bold">
            Licensed · Insured · South Florida Proud
          </div>
        </div>
      </div>
    </footer>
  );
}
